export default __webpack_public_path__ + "ca2d5589e57c5ca83b39387f22b3d16c.svg";